<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        .title {{ articulo.categoria }}{{ articulo.subcategoria !== '' ? ` - ${articulo.subcategoria}` : '' }}
        .columns
          .column.is-8
            strong {{ getTitle() }}&nbsp
          .column.is-4
            .file
              label.file-label
                input.file-input(
                type='file'
                name='docto'
                :multiple="getTypeInput()"
                @change="uploadDocumento($event)"
                :disabled="permisos.inventarios==6"
                )
                span.file-cta
                  span.file-icon
                    i.fas.fa-upload
                  span.file-label
                    | {{ getTextLabel() }}
        .columns.is-multine(v-show="tipo !== 'facturas'")
          .column(v-for="d in documentos" :key="d.id")
            a(:href="getRuta(d.ruta)" target="_blank" rel="noreferer noopener")
              div.conteiner-pdf(v-show="getExtFile(d.ruta)")
                a.button.is-rounded.is-large
                  span.icon
                    i.fas.fa-file-pdf
              div.conteiner-image(v-show="!getExtFile(d.ruta)")
                img.cover(:src="getRuta(d.ruta)")
            a.button.is-danger.is-rounded.is-small(@click="borrarDocumento(d)")
              | Borrar&nbsp
              span.icon
                i.fas.fa-trash
        .columns(v-show="tipo === 'facturas'")
          .column(v-show="articulo.rutaFac !== ''")
            a(:href="getRuta(articulo.rutaFac)" target="_blank" rel="noreferer noopener")
              div.conteiner-pdf
                a.button.is-rounded.is-large
                  span.icon
                    i.fas.fa-file-pdf
            a.button.is-danger.is-rounded.is-small(@click="borrarFactura(articulo)")
              | Borrar&nbsp
              span.icon
                i.fas.fa-trash
          .column(v-show="articulo.rutaFac === ''")
            span.tag.is-danger
              | No existen facturas registradas.
      button.modal-close.is-large.is-rounded(aria-label='close' @click.prevent="cerrarModal")
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'ModalDocumentosArt',
    props: {
      articulo: {
        type: Object,
        default: () => {}
      },
      tipo: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        documentos: [],
      }
    },
    watch: {
      articulo() {
        if (Object.keys(this.articulo).length > 0) {
          this.filterDocumentos()
        }
      }
    },
    methods: {
      cerrarModal() {
        this.$emit('padre:close', 'close')
      },

      getTitle () {
        switch (this.tipo) {
          case 'images':
            return 'Fotografías'
          case 'facturas':
            return 'Facturas'
          case 'polizas':
            return 'Pólizas'
          case 'tarjetaCirc':
            return 'Tarjeta de Circulación'
        }
      },

      getTextLabel () {
        switch (this.tipo) {
          case 'images':
            return 'Subir Fotos'
          case 'facturas':
            return 'Subir Factura'
          case 'polizas':
            return 'Subir Póliza'
          case 'tarjetaCirc':
            return 'Subir Tarjeta de Circulación'
        }
      },

      getTypeInput () {
        switch (this.tipo) {
          case 'images':
            return true
          case 'facturas':
            return false
          case 'polizas':
            return false
          case 'tarjetaCirc':
            return false
        }
      },

      uploadDocumento (e) {
        if (this.permisos.inventarios == 6) {
          return
        }
        this.$emit('subirDocumento', e.target.files)
      },

      getNombreFile (ruta) {
        const arrayRuta = ruta.split('/')
        const nameFile = arrayRuta[5]
        return nameFile
      },

      getRuta (ruta) {
        const currentUrl = window.location.hostname
        return `https://${currentUrl}${ruta}`
      },
      
      getExtFile (file) {
        const ext = file.substr(-3)
        return ext === 'pdf'
      },

      borrarFactura (docto) {
        if (this.permisos.inventarios == 6) {
          return
        }
        docto.tipo = 'factura'
        this.$emit('borrarDocumento', docto)
      },

      borrarDocumento (docto) {
        if (this.permisos.inventarios == 6) {
          return
        }
        docto.tipo = 'documento'
        this.$emit('borrarDocumento', docto)
      },

      filterDocumentos () {
        switch (this.tipo) {
          case 'images':
            this.documentos = this.articulo.documentos.filter( doc => doc.tipo === '0')
          break
          case 'polizas':
            this.documentos = this.articulo.documentos.filter( doc => doc.tipo === '2')
          break
          case 'responsivas':
            this.documentos = this.articulo.documentos.filter( doc => doc.tipo === '4')
          break
          case 'facturas':
            this.documentos = this.articulo.documentos.filter( doc => doc.tipo === '1')
          break
          case 'tarjetaCirc':
            this.documentos = this.articulo.documentos.filter( doc => doc.tipo === '3')
          break
        }
        
      }

    },
    created () {
      this.filterDocumentos()
    },
    computed: {
      ...mapState(['userLogin', 'permisos'])
    },
  }
</script>

<style lang="scss" scoped>
  .conteiner-image {
    width: 96px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .cover {
    border-radius: 10%;
    object-fit: fill;
    object-position: center;
    width: 100%;
    height: 100%;
  }
  .conteiner-pdf {
    width: 96px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/ModalDocumentosArt.vue